import React, { Component } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SkyeTileCardV2 from '../SkyeTileCardV2/SkyeTileCardV2.js';
import { $qs, bridgeCarouselControlsAA } from '../../helpers/misc-javascript-helpers.js';

class DesktopProductCarouselV2 extends Component {
    constructor(props) {
        super(props);
        this.nextCtlRef = React.createRef();
        this.prevCtlRef = React.createRef();
        this.state = {
            propsData: {},
            previousBtnStatus: 'inactive',
            nextBtnStatus: 'inactive',
            prevCtrlDisabled: false,
            nextCtrlDisabled: false
        };
        this.aa_controlsBridgeNext = this.aa_controlsBridgeNext.bind(this);
        this.aa_controlsBridgePrevious = this.aa_controlsBridgePrevious.bind(this);
        this.handlePrevBtnStateOnFocus = this.handlePrevBtnStateOnFocus.bind(this);
        this.handlePrevBtnStateOnBlur = this.handlePrevBtnStateOnBlur.bind(this);
        this.handleNextBtnStateOnFocus = this.handleNextBtnStateOnFocus.bind(this);
        this.handleNextBtnStateOnBlur = this.handleNextBtnStateOnBlur.bind(this);
        this.handleNextCtrlDisable = this._handleNextCtrlDisable.bind(this);
        this.handlePrevCtrlDisable = this._handlePrevCtrlDisable.bind(this);
    }

    /** Set up supplemental keyboard event (down key switches to next button) */
    aa_controlsBridgeNext(e) {
        bridgeCarouselControlsAA(e, 'previous-control__button', 'next-control__button', 'course-tile__block');
    };

    /** Set up supplemental keyboard event (up key switches to previous button) */
    aa_controlsBridgePrevious(e) {
        bridgeCarouselControlsAA(e, 'previous-control__button', 'next-control__button', 'course-tile__block');
    };

    /** Handles the previous control's focus event */
    handlePrevBtnStateOnFocus(e) {
        this.setState({ previousBtnStatus: 'active' });
    };

    /** Handles the previous control's blur event */
    handlePrevBtnStateOnBlur(e) {
        this.setState({ previousBtnStatus: 'inactive' });
    };

    /** Handles the next control's focus event */
    handleNextBtnStateOnFocus(e) {
        this.setState({ nextBtnStatus: 'active' });
    };

    /** Handles the next control's blur event */
    handleNextBtnStateOnBlur(e) {
        this.setState({ nextBtnStatus: 'inactive' });
    };

    _handleNextCtrlDisable(index) {
        const stageWidth = $qs('.slick-slider.slick-initialized');
        this.setState({ prevCtrlDisabled: false });
        if ((stageWidth.offsetWidth > 230 && stageWidth.offsetWidth < 260 && index === 24) ||
            (stageWidth.offsetWidth > 490 && stageWidth.offsetWidth < 500 && index === 23) ||
            (stageWidth.offsetWidth > 700 && stageWidth.offsetWidth < 750 && index === 22) ||
            (stageWidth.offsetWidth > 990 && stageWidth.offsetWidth < 1010 && index === 21) ||
            (stageWidth.offsetWidth > 1220 && stageWidth.offsetWidth < 1250 && index === 20)) {
            this.setState({ nextCtrlDisabled: true });
            this.prevCtlRef.current.focus();
        } else {
            this.setState({ nextCtrlDisabled: false });
        }
        if (index === 0) {
            this.setState({ prevCtrlDisabled: true });
            this.nextCtlRef.current.focus();
        }
    }

    _handlePrevCtrlDisable() {
        this.setState({ prevCtrlDisabled: true });
        this.nextCtlRef.current.focus();
    }

    render() {
        var settings = {
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 5,
            slidesToScroll: 5,
            adaptiveHeight: false,
            accessibility: true,
            afterChange: (index) => this.handleNextCtrlDisable(index),
            onInit: () => this.handlePrevCtrlDisable(),
            rows: 1,
            nextArrow: <NextArrow
                ref={this.nextCtlRef}
                onFocus={(e) => this.handleNextBtnStateOnFocus(e)}
                onBlur={(e) => this.handleNextBtnStateOnBlur(e)}
                onKeyDown={(e) => this.aa_controlsBridgeNext(e)}
                disableStatus={this.state.nextCtrlDisabled}
                onClick={(e) => console.log(e)}
            />,
            prevArrow: <PrevArrow
                ref={this.prevCtlRef}
                onFocus={(e) => this.handlePrevBtnStateOnFocus(e)}
                onBlur={(e) => this.handlePrevBtnStateOnBlur(e)}
                onKeyDown={(e) => this.aa_controlsBridgePrevious(e)}
                disableStatus={this.state.prevCtrlDisabled}
                onClick={(e) => console.log(e)}
            />,
            responsive: [
                {
                    breakpoint: 375,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinte: false,
                        dots: false
                    }
                },
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinte: false,
                        dots: false
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinte: false,
                        dots: false
                    }
                },
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 2,
                        infinte: true,
                        dots: false
                    }
                },
                {
                    breakpoint: 1279,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 2,
                        infinte: true,
                        dots: false
                    }
                },
                {
                    breakpoint: 1399,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 3,
                        infinte: true,
                        dots: false
                    }
                },
                {
                    breakpoint: 1599,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 4,
                        infinte: true,
                        dots: false
                    }
                }
            ]
        };
        return (
            <React.Fragment>
                <Slider {...settings}>
                    {(typeof this.props.data !== 'undefined') ? this.props.data.map((tileData, index) =>

                        <SkyeTileCardV2
                            key={index}
                            image={tileData.icon}
                            title={(tileData.title) ? tileData.title : tileData.suite_name}
                            category={tileData.category}
                            link={this.props.route + ((tileData.course_id) ? tileData.course_id : tileData.suite_id) + '/' + tileData.slug}
                            rating={(tileData.rating) ? tileData.rating : 'new'}
                            duration={tileData.length}
                            domain_id={this.props.domainId}
                            product_type={((tileData.course_id) ? 'course' : 'suite')}
                            price={tileData.product_info.list_price}
                            strikePrice={tileData.product_info.strikethrough_price}
                        />

                    ) : ''}
                </Slider>
                <div className="exit-slider"></div>
            </React.Fragment>
        );
    }
}

export const PrevArrow = React.forwardRef((props, ref) => {
    const { onClick, onBlur, onFocus, onKeyDown, disableStatus } = props;
    return (
        <div className="previous-control__block">
            <button className={(disableStatus) ? 'previous-control__button btn bmd-btn-fab disabled' : 'previous-control__button btn bmd-btn-fab'}
                ref={ref}
                onClick={onClick}
                onBlur={onBlur}
                onFocus={onFocus}
                onKeyDown={onKeyDown}
                disabled={disableStatus}
                aria-label={'Previous Button for Certificates Carousel. Press down key for next button. To access the certificates press the left or right keys, then use tab to view each item.'}
                tabIndex="0">
                <i className={"fas fa-angle-left"} aria-hidden="true"></i>
            </button>
        </div>
    );
});

export const NextArrow = React.forwardRef((props, ref) => {
    const { onClick, onBlur, onFocus, onKeyDown, disableStatus } = props;
    if (props.dataLength > 0) {
        styles = { zIndex: 0 };
    }
    return (
        <div className="next-control__block">
            <button className={(disableStatus) ? 'next-control__button btn bmd-btn-fab disabled' : 'next-control__button btn bmd-btn-fab'}
                ref={ref}
                onClick={onClick}
                onBlur={onBlur}
                onFocus={onFocus}
                onKeyDown={onKeyDown}
                disabled={disableStatus}
                aria-label={'Next Button for Certificates Carousel. Press up key for previous button. To access the certificates press the left or right keys, then use tab to view each item.'}
                tabIndex="0">
                <i className={"fas fa-angle-right"} aria-hidden="true"></i>
            </button>
        </div>
    );
});


export default DesktopProductCarouselV2;